import classnames from 'classnames';
import s from './index.module.scss';

export const OptionBase = props => {
  const { innerProps, isSelected, data: country } = props;
  return (
    <div {...innerProps} className={classnames(s.base, isSelected && s.base_selected)}>
      <div className={s.base_name}>{country.label}</div>
    </div>
  );
};
